import { render, staticRenderFns } from "./RetencionForm.vue?vue&type=template&id=22133747"
import script from "./RetencionForm.vue?vue&type=script&lang=js"
export * from "./RetencionForm.vue?vue&type=script&lang=js"
import style0 from "./RetencionForm.vue?vue&type=style&index=0&id=22133747&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports